/**
 * modal.ts — SweetAlert2 wrapper
 * Basit, güvenilir, test edilmiş modal fonksiyonları
 */

import Swal from 'sweetalert2';

/**
 * Hata modalı göster
 */
export async function showErrorModal(title: string, message: string): Promise<void> {
  await Swal.fire(title, message, 'error');
}

/**
 * Uyarı modalı göster
 */
export async function showWarningModal(title: string, message: string): Promise<void> {
  await Swal.fire(title, message, 'warning');
}

/**
 * Bilgi modalı göster
 */
export async function showInfoModal(title: string, message: string): Promise<void> {
  await Swal.fire(title, message, 'info');
}

/**
 * Başarı modalı göster
 */
export async function showSuccessModal(title: string, message: string): Promise<void> {
  await Swal.fire(title, message, 'success');
}

/**
 * Onay modalı göster
 */
export async function showConfirmModal(title: string, message: string): Promise<boolean> {
  const result = await Swal.fire({
    title: title,
    text: message,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Evet',
    cancelButtonText: 'Hayır'
  });
  return result.isConfirmed;
}

/**
 * Gelişmiş modal için interface
 */
export interface ModalOptions {
  title: string;
  html: string;
  icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
  showCancelButton?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  allowOutsideClick?: boolean;
  allowEscapeKey?: boolean;
  didOpen?: () => void;
  preConfirm?: () => any;
}

export interface ModalResult<T = any> {
  isConfirmed: boolean;
  isDismissed: boolean;
  value?: T;
}

/**
 * Gelişmiş modal göster (PIN modal için)
 */
export async function showModal<T = any>(options: ModalOptions): Promise<ModalResult<T>> {
  const result = await Swal.fire({
    title: options.title,
    html: options.html,
    icon: options.icon,
    showCancelButton: options.showCancelButton ?? false,
    confirmButtonText: options.confirmButtonText ?? 'Tamam',
    cancelButtonText: options.cancelButtonText ?? 'İptal',
    allowOutsideClick: options.allowOutsideClick ?? false,
    allowEscapeKey: options.allowEscapeKey ?? true,
    didOpen: options.didOpen,
    preConfirm: options.preConfirm
  });

  return {
    isConfirmed: result.isConfirmed,
    isDismissed: result.isDismissed || false,
    value: result.value
  };
}
